function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#SVGID_1_)}.st1{fill:url(#SVGID_2_)}.st2{fill:url(#SVGID_3_)}.st3{fill:url(#SVGID_4_)}");

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  y1: 112.094,
  x2: 261.746,
  y2: 112.094
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#63be6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.506,
  stopColor: "#5bbc6a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4ab96a"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M261.7 142.3L15 1.3C11.9-.5 8-.4 5 1.4c-3.1 1.8-5 5-5 8.6 0 0 .1 13 .2 34.4l179.7 179.7 81.8-81.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 0.152,
  y1: 223.393,
  x2: 179.896,
  y2: 223.393
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ec6f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#45afe3"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M.2 44.4C.5 121.6 1.4 309 1.8 402.3L180 224.1.2 44.4z"
});

var _ref7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 179.896,
  y1: 229.464,
  x2: 407.976,
  y2: 229.464
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#faa51a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.387,
  stopColor: "#fab716"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.741,
  stopColor: "#fac412"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fac80f"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M402.9 223l-141.2-80.7-81.9 81.8 92.4 92.4L403 240.3c3.1-1.8 5-5.1 5-8.6 0-3.6-2-6.9-5.1-8.7z"
});

var _ref9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 1.744,
  y1: 345.521,
  x2: 272.296,
  y2: 345.521
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ec3b50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e7515b"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M1.7 402.3c.2 33.3.3 54.6.3 54.6 0 3.6 1.9 6.9 5 8.6 3.1 1.8 6.9 1.8 10 0l255.3-148.9-92.4-92.4L1.7 402.3z"
});

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 408 466.9",
    width: 2185,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.d6b7bc99.svg";
export { ForwardRef as ReactComponent };